export interface ReadImage {
  name: string;
  dataUrl: string;
  file: File;
  sizeError: boolean;
}

// Reads an image file into the shape the upload previews use.
export function readImageFile(file: File, maxFileSize: number): Promise<ReadImage> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve({
      name: file.name,
      dataUrl: reader.result as string,
      file,
      sizeError: file.size > maxFileSize,
    });
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
